module.exports = __webpack_public_path__ + "assets/img/tab.81e948d5.png";